export const rootStyles = {
  display: 'flex',
  justifyContent: 'center',
  marginY: 1,
};

export const bodyStyles = {
  paddingX: 1.5,
  paddingY: 0.5,
  borderRadius: 1,
  backgroundColor: theme => theme.palette.action.hover,
  color: theme => theme.palette.text.secondary,
  textAlign: 'center',
  maxWidth: '80%',
};
